// ManageProducts.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import './ManageProducts.css';

export default function ManageProducts() {
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    id: null,
    name: '', description: '', price: '', quantity: '', diamond_quality: '',
    diamond_weight: '', gold_weight: '', metal_quality: [], metal_colors: [],
    collections: [], images: [], category: '',  // Updated to store text (not category_id)
    product_type: '',  price_18kt: '', // Price for 18kt
  price_14kt: '', // Price for 14kt

  });
  const [colorImageMap, setColorImageMap] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 5;

    const [categories, setCategories] = useState([]);
  const [productTypes, setProductTypes] = useState([]);

  useEffect(() => { fetchProducts(); }, []);

  const fetchProducts = async () => {
    const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/products');
    setProducts(res.data);
  };

   useEffect(() => {
    // Fetch categories when component mounts
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/categories');
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchProductTypes = async (category) => {
    try {
      const res = await axios.get(`https://spinelleapi.emedha.in/admin/product/api/product_types/${category}`);
      setProductTypes(res.data);
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleMultiSelect = (e, field) => {
    const { value, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [field]: checked ? [...prev[field], value] : prev[field].filter((v) => v !== value)
    }));
  };


  const [additionalImages, setAdditionalImages] = useState([]);
  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setForm({ ...form, category });
    fetchProductTypes(category);  // Fetch product types based on selected category
  };

  const handleProductTypeChange = (e) => {
    setForm({ ...form, product_type: e.target.value });
  };


  const handleImageUpload = (e, color) => {
    const files = Array.from(e.target.files);
    setColorImageMap((prev) => ({ ...prev, [color]: files }));
  };

const handleAdditionalImageUpload = (e) => {
  const files = Array.from(e.target.files);
  setAdditionalImages((prev) => [...prev, ...files]);
};

const removeAdditionalImage = (index) => {
  const updatedFiles = [...additionalImages];
  updatedFiles.splice(index, 1);
  setAdditionalImages(updatedFiles);
};

const removeImage = (color, index) => {
  setColorImageMap((prev) => {
    const updatedFiles = [...(prev[color] || [])];
    updatedFiles.splice(index, 1);
    return { ...prev, [color]: updatedFiles };
  });
};


// Handling form submission to correctly associate images with colors
const submitProduct = async () => {
  const formData = new FormData();

  // Add form fields to the formData (for basic fields like name, description, etc.)
  Object.keys(form).forEach((key) => {
    if (Array.isArray(form[key])) {
      form[key].forEach((v) => formData.append(`${key}[]`, v));
    } else {
      formData.append(key, form[key]);
    }
  });

  // Adding color-wise images
  Object.entries(colorImageMap).forEach(([color, files]) => {
    files.forEach((file) => {
      formData.append(`color_images[${color}][]`, file); // Color-specific file upload
    });
  });

  // Additional product images (if any)
  additionalImages.forEach((file) => {
    formData.append('additional_images[]', file);
  });

  try {
    // Sending the form data to the API
    await axios.post('https://spinelleapi.emedha.in/admin/product/api/products', formData);
    resetForm();
    fetchProducts();
  } catch (error) {
    console.error('Error adding product:', error);
  }
};



const resetForm = () => {
  setForm({
    id: null,
    name: '', description: '', price: '', quantity: '', diamond_quality: '',
    diamond_weight: '', gold_weight: '', metal_quality: [], metal_colors: [],
    collections: [], images: []
  });
  setColorImageMap({});
  setAdditionalImages([]);
};


  return (
    <div className="manage-products-container">
      <h2>{form.id ? 'Edit Product' : 'Add Product'}</h2>
      <div className="form-section">
        <input name="name" placeholder="Product Name" value={form.name} onChange={handleInputChange} />
                <select name="category" value={form.category} onChange={handleCategoryChange}>
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.id} value={category.name}>{category.name}</option>
          ))}
        </select>

        {/* Product Type Select */}
        <select name="product_type" value={form.product_type} onChange={handleProductTypeChange}>
          <option value="">Select Product Type</option>
          {productTypes.map((productType) => (
            <option key={productType.id} value={productType.name}>{productType.name}</option>
          ))}
        </select>
        <textarea name="description" placeholder="Description" value={form.description} onChange={handleInputChange}></textarea>
              <input name="quantity" placeholder="Quantity" value={form.quantity} onChange={handleInputChange} />
         <div className="checkbox-group">
          <label>Metal Quality:</label>
          {['18kt', '14kt'].map((q) => (
            <label key={q}><input type="checkbox" checked={form.metal_quality.includes(q)} value={q} onChange={(e) => handleMultiSelect(e, 'metal_quality')} />{q}</label>
          ))}
        </div>

       {form.metal_quality.includes('18kt') && (
  <div className="input-group">
    <label>Price for 18kt:</label>
    <input 
      type="number" 
      name="price_18kt" 
      value={form.price_18kt} 
      onChange={handleInputChange} 
      placeholder="Enter price for 18kt" 
    />
  </div>
)}

{form.metal_quality.includes('14kt') && (
  <div className="input-group">
    <label>Price for 14kt:</label>
    <input 
      type="number" 
      name="price_14kt" 
      value={form.price_14kt} 
      onChange={handleInputChange} 
      placeholder="Enter price for 14kt" 
    />
  </div>
)}
   

      
        <div className="checkbox-group">
          <label>Metal Colors:</label>
          {['Rose Gold', 'Yellow Gold', 'White Gold'].map((color) => (
            <label key={color}><input type="checkbox" checked={form.metal_colors.includes(color)} value={color} onChange={(e) => handleMultiSelect(e, 'metal_colors')} />{color}</label>
          ))}
        </div>

        {/* <div className="checkbox-group">
          <label>Diamond Quality:</label>
          {['EF/VVS', 'GH/VS'].map((dq) => (
            <label key={dq}><input type="radio" name="diamond_quality" checked={form.diamond_quality === dq} value={dq} onChange={handleInputChange} />{dq}</label>
          ))}
        </div> */}

        <div className="checkbox-group">
          <label>Collections:</label>
          {['Daily Wear', 'Gemstone', 'Designer', 'Solitaire', 'Lightweight'].map((c) => (
            <label key={c}><input type="checkbox" checked={form.collections.includes(c)} value={c} onChange={(e) => handleMultiSelect(e, 'collections')} />{c}</label>
          ))}
        </div>

        <input name="diamond_weight" placeholder="Diamond Weight" value={form.diamond_weight} onChange={handleInputChange} />
        <input name="gold_weight" placeholder="Gold Weight" value={form.gold_weight} onChange={handleInputChange} />

<div className="image-upload-section">
  <label>Upload Images by Color:</label>
  {['Rose Gold', 'Yellow Gold', 'White Gold'].map((color) => (
    <div key={color} className="upload-group">
      <div className="upload-header">
        <label>{color}</label>
        <input type="file" multiple onChange={(e) => handleImageUpload(e, color)} />
      </div>
      <div className="preview-images">
        {colorImageMap[color] &&
          colorImageMap[color].map((file, index) => (
            <div key={index} className="preview-thumb">
              <img src={file instanceof File ? URL.createObjectURL(file) : file} alt={color} />
              <button onClick={() => removeImage(color, index)}>x</button>
            </div>
          ))}
      </div>
    </div>
  ))}
</div>

{/* Additional Product Images Section */}
<div className="additional-images-section">
  <label>Upload Additional Product Images:</label>
  <input type="file" multiple onChange={handleAdditionalImageUpload} />
  <div className="preview-images">
    {additionalImages.map((file, index) => (
      <div key={index} className="preview-thumb">
        <img src={file instanceof File ? URL.createObjectURL(file) : file} alt="additional" />
        <button onClick={() => removeAdditionalImage(index)}>x</button>
      </div>
    ))}
  </div>
</div>


        <button onClick={submitProduct}>Add Product</button>
       
      </div>


    </div>
  );
}
